// extracted by mini-css-extract-plugin
export default {"buttonToolbar":"BoxToolbar_buttonToolbar__ilLFt"};